import PieChart from "../../../../../src/core/PieChart";
import { Playground } from 'docz';
import * as React from 'react';
export default {
  PieChart,
  Playground,
  React
};